import React, { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

export const FooterLeft = (props) => {
	const { children, className, ...rest } = props;

	return (
		<div
			data-component-name='Footer/FooterLeft'
			className={classNames(
				'flex items-center gap-4',
				'ltr:md:mr-auto rtl:md:ml-auto',
				className,
			)}
			{...rest}>
			{children}
		</div>
	);
};
FooterLeft.displayName = 'FooterLeft';

export const FooterRight = (props) => {
	const { children, className, ...rest } = props;

	return (
		<div
			data-component-name='Footer/FooterRight'
			className={classNames(
				'flex items-center gap-4',
				'ltr:md:ml-auto rtl:md:mr-auto',
				className,
			)}
			{...rest}>
			{children}
		</div>
	);
};
FooterRight.displayName = 'FooterRight';

const Footer = (props) => {
	const { children, className, ...rest } = props;

	return (
		<footer
			data-component-name='Footer'
			className={classNames('flex justify-between gap-4 p-6 text-sm', className)}
			{...rest}>
			{children}
		</footer>
	);
};
Footer.displayName = 'Footer';

export default Footer;
